import { ShaderModule, LambdaSource, StorageSource, TextureSource, DataBinding } from './types';

import { makeBindingAccessors, makeUniformRender } from './gen';
import { makeResolveBindings } from '../util/bind';
import { VIRTUAL_BINDGROUP, VOLATILE_BINDGROUP } from './constants';

import { attributeToFields } from './shader';

export { bindBundle, bindModule } from '../util/bind';

const getVirtualBindGroup = () => VIRTUAL_BINDGROUP;

export const bindingToModule = (
  binding: DataBinding,
): ShaderModule => {
  const {attribute: {name}} = binding;
  const links = makeBindingAccessors([binding], VIRTUAL_BINDGROUP, VOLATILE_BINDGROUP);
  const module = links[name];
  return {...module, entry: name};
}

export const bindingsToModules = (
  bindings: DataBinding[],
): Record<string, ShaderModule> => {
  return makeBindingAccessors(bindings, VIRTUAL_BINDGROUP, VOLATILE_BINDGROUP);
}

export const sourceToModule = <T>(
  source: ShaderModule | LambdaSource<T> | StorageSource | TextureSource | any,
): ShaderModule | null => {
  if (source == null) return null;

  const s = source as any;
  if (s.shader) return s.shader as ShaderModule;
  else if (s.module || s.table) return source as ShaderModule;
  return null;
}

export const resolveBindings = makeResolveBindings(attributeToFields, makeUniformRender, getVirtualBindGroup);
